var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserWithCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1667 5.33335C10.1667 6.52997 9.19663 7.50002 8.00001 7.50002C6.80339 7.50002 5.83334 6.52997 5.83334 5.33335C5.83334 4.13674 6.80339 3.16669 8.00001 3.16669C9.19663 3.16669 10.1667 4.13674 10.1667 5.33335Z",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16665 12.8333H4.63301C3.84668 12.8333 3.25991 12.1402 3.66056 11.4636C4.24163 10.4823 5.49289 9.33331 8.16665 9.33331",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 12.8333L10.5 10.5",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.8333L12.8333 10.5",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWithCross);
export default __webpack_public_path__ + "static/media/userWithCross.76dad73947f3bda950e2faebcdecb759.svg";
export { ForwardRef as ReactComponent };